<template>
  <div class="visit-object">
    <title-bar
      :title="$t('Gattaran_0_Select_Contact_UrRS' /** 选择联系人 */)"
      show-back
      @back="back"
    />
    <rich-load-list
      ref="scroll"
      class="visit-object-list-wrapper"
      :pull-down-refresh="false"
      :pull-up-load="false"
    >
      <ul v-if="visitObjectList.length" class="visit-object-list">
        <li
          v-for="(item, index) in visitObjectList"
          :key="index"
          :class="[
            {
              'visit-object-list-item': true,
              selected:
                item.contactId === selectedPerson.contactId &&
                item.roleId === selectedPerson.roleId,
            },
          ]"
          @click="select(item)"
        >
          <rich-card>
            <h3 slot="header" class="item-header">
              <em class="contact-name">{{ item.name }}</em>
              <span class="contact-role">{{ item.roleDesc }}</span>
              <i class="crm-Icon_edit" @click.stop="toEdit(item)"></i>
            </h3>
            <ul v-if="country === 'BR'" slot="body" class="item-body">
              <li class="contact-phone">
                <i class="crm-Icon-phone"></i>
                <span v-if="item.phone">{{ item.phone }}</span>
                <span v-else class="phone-error">{{
                  $t('Gattaran_form_hRvn_xomV' /** 电话是必填的 */)
                }}</span>
              </li>
              <li class="contact-email">
                <i class="richic-email"></i>
                <span v-if="item.mail">{{ item.mail }}</span>
                <span v-else class="email-error"> -</span>
              </li>
              <li class="contact-time">
                <i class="icon-filled_history"></i>
                <span v-for="(time, timeIdx) in item.contactTime" :key="timeIdx">
                  {{ time.startTime }}-{{ time.endTime }}
                </span>
              </li>
              <li class="contact-way">
                <i class="icon-filled_collected"></i>
                <span>
                  {{
                    item.contactMode && item.contactMode.length
                      ? item.contactMode
                          .map(mode => {
                            return mode.value || ''
                          })
                          .join('; ')
                      : ' - '
                  }}
                </span>
              </li>
            </ul>
            <ul v-else slot="body" class="item-body">
              <li class="contact-way">
                <i class="icon-filled_collected"></i>
                <span>
                  {{
                    item.contactMode && item.contactMode.length
                      ? item.contactMode
                          .map(mode => {
                            return mode.value || ''
                          })
                          .join('; ')
                      : ' - '
                  }}
                </span>
              </li>
              <li class="contact-phone">
                <i class="crm-Icon-phone"></i>
                <span v-if="item.phone">{{ item.phone }}</span>
                <span v-else> -</span>
              </li>
              <li class="contact-email">
                <i class="richic-email"></i>
                <span v-if="item.mail">{{ item.mail }}</span>
                <span v-else> -</span>
              </li>
              <li class="contact-whatsapp">
                <i class="richic-mobile-phone"></i>
                <span v-if="item.whatsappPhone">{{ item.whatsappPhone }}</span>
                <span v-else> -</span>
              </li>
              <li class="contact-time">
                <i class="icon-filled_history"></i>
                <span v-for="(time, timeIdx) in item.contactTime" :key="timeIdx">
                  {{ time.startTime }}-{{ time.endTime }}
                </span>
              </li>
            </ul>
          </rich-card>
          <div class="item-selected-icon">
            <i class="crm-icon-claimed"></i>
          </div>
        </li>
      </ul>
      <div v-if="loading === false && !visitObjectList.length" class="no-person">
        <i class="crm-icon_tips"></i>
        <span>{{ $t('Gattaran_0_No_contacts_EeBR' /** 没有联系人 */) }}</span>
      </div>
      <!-- 已设置42个联系人则无法再新增 -->
      <rich-button v-if="visitObjectList.length < 42" class="add-visit-object-btn" @click="toAdd">
        <i class="crm-Icon-claim"></i>
        <span>{{ $t('Gattaran_0_Create_new_Faau' /** 新建联系人 */) }}</span>
      </rich-button>
    </rich-load-list>
    <div class="confirm">
      <rich-button
        class="confirm-btn"
        :disabled="!selectedPerson.contactId && !selectedPerson.roleId"
        @click="confirm"
      >
        <span>{{ gettext('确定') }}</span>
      </rich-button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import TitleBar from '@/components/TitleBar'
import { getVisitObjectInit } from '@/api'
import Vue from 'vue'
import AddVisitObject from '../AddVisitObject/index.vue'
import { getBDCountry } from '@/common/utils/i18n'
Vue.use(AddVisitObject)
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
export default {
  name: 'VisitObjectList',
  components: {
    TitleBar
  },
  props: {
    options: {}
  },
  data () {
    const country = getBDCountry() || 'MX'
    return {
      loading: false,
      shopId: this.$route.query.shopId,
      visitObjectList: [],
      selectedPerson: {},
      country,
    }
  },
  computed: {
    roleList () {
      return this.options.roleId?.enum || []
    },
    contactModeList () {
      return this.options.contactMode?.enum
    }
  },
  mounted () {
    this.fetchVisitObject()
  },
  methods: {
    fetchVisitObject () {
      this.loading = true
      const loading = this.$createToast({ mask: true })
      loading.show()

      getVisitObjectInit({
        shopId: this.shopId,
        pageSize: 5
      }).then(res => {
        this.visitObjectList = res.visitObjectList || []
        this.loading = false
        loading.hide()
      })
    },
    select (item) {
      if (item.contactId !== this.selectedPerson.contactId && item.roleId !== this.selectedPerson.roleId) {
        this.selectedPerson = item
      } else {
        this.selectedPerson = {}
      }
    },
    toAdd () {
      const addInstance = this.$createAddVisitObjectPopup({
        $props: {
          options: this.options,
          isEdit: false
        },
        $events: {
          back: () => addInstance.remove(),
          save: this.fetchVisitObject
        }
      }).show()
    },
    toEdit (item) {
      const editInstance = this.$createAddVisitObjectPopup({
        $props: {
          options: this.options,
          roleId: item.roleId,
          isEdit: true,
          contactId: item.contactId
        },
        $events: {
          back: () => editInstance.remove(),
          save: this.fetchVisitObject
        }
      }).show()
    },
    confirm () {
      const selectedContactId = this.selectedPerson.contactId
      const selectedPersonInfo = this.visitObjectList.find(
        person => person.contactId === selectedContactId && person.roleId === this.selectedPerson.roleId
      )
      this.$emit('confirm', selectedPersonInfo)
    },
    back () {
      this.$emit('back')
    },
    getContactModeByKey (key) {
      return this.contactModeList.find(mode => mode.key === key)
    }
  }
}
</script>

<style lang="scss" scoped>
.visit-object {
  position: relative;
  height: 100%;

  .list-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 312px;
  }

  .no-person {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 312px;
    margin: 24px 0;
    padding: 32px 24px 0 24px;
    box-sizing: border-box;
    border-radius: 16px;
    background-color: #ffffff;

    i {
      width: 64px;
      height: 64px;
      color: #b5b5b5;
      font-size: 64px;
    }

    span {
      margin-top: 8px;
      font-size: 28px;
      color: #595c66;
      text-align: center;
      line-height: 36px;
    }
  }

  &-list-wrapper {
    padding: 0 24px 120px 24px;
    background-color: #f2f3f6;
    height: calc(100vh - 100px - 152px - var(--barheight));
    box-sizing: border-box;
  }

  &-list {
    overflow: hidden;

    &-item {
      position: relative;
      margin: 24px 0;
      height: 358px;
      width: calc(100% - 2px);
      padding: 32px 24px 0 24px;
      box-sizing: border-box;
      border-radius: 16px;
      background-color: #ffffff;
      overflow: hidden;

      .item-selected-icon {
        visibility: hidden;
      }

      &.selected {
        @include border-1px(#f76a31, 16px, solid);

        .item-selected-icon {
          visibility: visible;
          position: absolute;
          bottom: 0;
          right: 0;
          height: 56px;
          width: 56px;
          background-image: linear-gradient(
            135deg,
            #ffffff 0,
            #ffffff 50%,
            #f76a31 51%,
            #f76a31 100%
          );

          .crm-icon-claimed {
            position: absolute;
            right: 4px;
            bottom: 5px;
            font-size: 20px;
            color: #ffffff;
          }
        }
      }

      .item-header {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .contact-name {
          font-family: DiDiSans-Pro-Medium;
          font-size: 36px;
          font-style: normal;
          color: #282b33;
          line-height: 44px;
          padding-right: 10px;
          max-width: 40%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
        }
        .contact-role {
          position: relative;
          font-size: 32px;
          color: #8d9099;
          line-height: 40px;
          padding-left: 10px;
          max-width: 40%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;

          &::before {
            position: absolute;
            top: 0;
            left: 0;
            content: '';
            display: block;
            height: 40px;
            width: 1px;
            background-color: #e9eaee;
          }
        }
        .crm-Icon_edit {
          position: absolute;
          right: 24px;
          display: flex;
          justify-content: flex-end;
          font-size: 48px;
        }
      }

      .item-body {
        padding-top: 12px;
        .phone-error {
          color: #f93c32;
        }
        li {
          font-family: DiDiSans-Pro-Regular;
          font-size: 28px;
          color: #282b33;
          line-height: 36px;
          padding-top: 12px;
          text-align: left;
          display: flex;
          align-items: center;
          i {
            color: #8d9099;
            padding-right: 16px;
            font-size: 24px;
          }
        }
      }
    }
  }

  ::v-deep .add-visit-object-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    border-radius: 16px;
    text-align: center;
    background: #fff;

    i {
      font-size: 24px;
      color: #282b33;
    }
    span {
      padding-left: 16px;
      font-size: 32px;
      color: #282b33;
      font-weight: 400;
    }
  }

  .confirm {
    background-color: #ffffff;
    padding: 20px 24px 40px 24px;
    &-btn {
      font-family: DiDiSans-Pro-Bold;
      font-size: 32px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
    }
  }
}
</style>
